export default __webpack_public_path__ + "static/media/outdoor-portrait.c5587e27.jpg";